

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    {
        const PAGE = document.querySelector('.ProductHolderPage')
        if(!PAGE) return

        const categories = PAGE.querySelectorAll('.category-card')

        const timeline = gsap.timeline({
            ease: 'power2.inOut'
        })

        timeline.to(categories, { stagger: {
            each: 0.05,
            from: 'random'
        }, opacity: 1 })
    }
}
